module.exports = __webpack_public_path__ + "assets/fonts/iconfont.6790572f.woff";